export default "__VITE_ASSET__6j3KXSMC__"